import { useState } from "react";

import {
    type AppointmentReminder,
    AppointmentTypeFilterOption,
} from "@accurx/api/appointment";
import { Ds } from "@accurx/design";

import { ViewReminderDetailsModal } from "../../ViewReminderDetailsModal";

type PreviewCardNonAdminButtonProps = {
    reminder: AppointmentReminder;
    appointmentTypeOptions: AppointmentTypeFilterOption[];
    workspaceHasMultipleSites: boolean;
    workspaceName?: string;
};

export const PreviewCardNonAdminButtons = ({
    reminder,
    appointmentTypeOptions,
    workspaceHasMultipleSites,
    workspaceName,
}: PreviewCardNonAdminButtonProps) => {
    const [isDetailModalShowing, setIsDetailModalShowing] = useState(false);

    return (
        <>
            <Ds.Flex
                gap="2"
                flexWrap={{ xs: "wrap", md: "nowrap" }}
                justifyContent="flex-end"
            >
                <Ds.Button
                    appearance="secondary"
                    size="medium"
                    onClick={() => setIsDetailModalShowing(true)}
                >
                    View details
                </Ds.Button>
            </Ds.Flex>
            <ViewReminderDetailsModal
                isOpen={isDetailModalShowing}
                onOpenChange={() => {
                    setIsDetailModalShowing((prev) => !prev);
                }}
                reminder={reminder}
                appointmentTypeOptions={appointmentTypeOptions}
                workspaceHasMultipleSites={workspaceHasMultipleSites}
                workspaceName={workspaceName}
            />
        </>
    );
};
